export default __webpack_public_path__ + "static/team01-cec65e0b1d6c20b86ba021ad2d16bfca.webp";